import { BuyBoxStateMeta } from '../types';

export const initialBuyBoxMetaState: BuyBoxStateMeta = {};
